import { render, staticRenderFns } from "./bloodRanges.vue?vue&type=template&id=f58ffcaa&scoped=true&"
import script from "./bloodRanges.vue?vue&type=script&lang=js&"
export * from "./bloodRanges.vue?vue&type=script&lang=js&"
import style0 from "./bloodRanges.vue?vue&type=style&index=0&id=f58ffcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58ffcaa",
  null
  
)

export default component.exports